import hasCorrectionBoxChanged from "./has-correction-box-changed.function";
import {
  ShippingManifestDestinationCorrectionBoxValue,
  ShippingManifestDestinationCorrectionFormValue,
  ShippingManifestDestinationCorrectionShipmentValue,
} from "./shipping-manifest-destination-correction-form.value";

export default function buildCorrectionRequest(
  shippingManifest: string,
  distributionCenter: string,
  shipments: ShippingManifestDestinationCorrectionShipmentValue[],
  boxDrafts: Record<string, ShippingManifestDestinationCorrectionBoxValue>,
  isBoxParametersRequired: boolean
): ShippingManifestDestinationCorrectionFormValue {
  const request: ShippingManifestDestinationCorrectionFormValue = {
    shippingManifest,
    distributionCenter,
  };

  if (!isBoxParametersRequired) {
    return request;
  }

  const bulkShipments = shipments
    .filter((shipment) =>
      hasCorrectionBoxChanged(shipment.box, boxDrafts[shipment.id])
    )
    .map((shipment) => ({
      id: shipment.id,
      box: { ...boxDrafts[shipment.id] },
    }));

  if (bulkShipments.length > 0) {
    request.bulkShipments = bulkShipments;
  }

  return request;
}
